<template>
  <div>
    <div v-if="wxQuickLoginLoading" class="wx-quick-login-loading" aria-live="polite">
      <i class="el-icon-loading"></i>
      <span>微信登录中...</span>
    </div>
    <!-- <el-backtop :bottom="100"></el-backtop> -->
    <div class="fix_right_handle">
      <div class="fix_main">
        <div class="fixed_other_handle">
          <div class="other_handle_name" @click="materialTest()">
            <img src="../../assets/img/clcs2.png" /><br />材料测试
          </div>
          <el-divider></el-divider>
          <div class="other_handle_name" @click="releaseRequire()">
            <img src="../../assets/img/fbxq.png" /><br />发布需求
          </div>
          <el-divider></el-divider>
          <div class="other_handle_name" @click="toTop">
            <img src="../../assets/img/fhdb.png" /><br />返回顶部
          </div>
        </div>
      </div>
    </div>
    <!-- <live800-js-590198></live800-js-590198> -->
    <homeHeader :menuFontColor="menuFontColor" :menuBgcolor="menuBgcolor"></homeHeader>
    <menuList ref="scrollOne"></menuList>
    <router-view />
    <homeFooter ref="scrollTwo"></homeFooter>
    <!-- 活动弹框 -->
    <CheckActivityDlg ref="checkActivityDlgRef"></CheckActivityDlg>
  </div>
</template>

<script type="text/javascript"></script>
<script>
import homeHeader from "../components/Header";
import menuList from "../components/menuList";
import homeFooter from "../components/Footer";
import CheckActivityDlg from "./components/CheckActivityDlg";
import { getDicts, wxQuickLogin } from "@/api/request";
import { getClient, getToken, setLoginCookie, setToken } from "@/plugins/auth";

export default {
  name: "Home",
  components: {
    homeHeader,
    menuList,
    homeFooter,
    CheckActivityDlg,
    //  'live800-js-590198': {
    //   render(createElement) {
    //     return createElement('script', {
    //       attrs: {
    //         type: 'text/javascript',
    //         src:"https://chat56.live800.com/live800/chatClient/monitor.js?jid=9350194081&companyID=1622974&configID=590198&codeType=custom&ss=1&delayload=1",
    //         },
    //       },
    //     );
    //   },
    // },
  },
  data() {
    return {
      menuFontColor: "",
      menuBgcolor: "#fff",
      actiive_space_dialog: false,
      active_config: null,
      userInfo: {},
      wxQuickLoginLoading: false,
    };
  },
  async mounted() {
    if (this.$route.query.code) {
      const quickLoginSucceeded = await this.handleWxQuickLogin(this.$route.query.code);
      if (quickLoginSucceeded) {
        this.userInfo = JSON.parse(getClient());
        await this.getCheckActivityPopStatus();
        return;
      }
    }
    if (getToken()) {
      await this.$store.dispatch("GetInfo")
      this.userInfo = JSON.parse(getClient())
      await this.getCheckActivityPopStatus();
    }
    // window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    // document.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    // 处理微信授权回调，完成 token 写入和用户上下文初始化后清理授权参数。
    async handleWxQuickLogin(code) {
      this.wxQuickLoginLoading = true;
      try {
        const response = await wxQuickLogin({ loginCode: code });
        const token = response.token || (response.data && (response.data.token || response.data.access_token));
        if (response.code !== 200 || !token) throw new Error("微信快速登录失败");

        setToken(token);
        setLoginCookie(token);
        this.$store.commit("SET_TOKEN", token);
        this.$store.commit("SET_LOGINFLAG", 1);
        await Promise.all([
          this.$store.dispatch("GetInfo"),
          this.$store.dispatch("setKefuQRCode"),
        ]);

        await this.clearWxQuickLoginQuery();
        this.$message.success("登录成功");
        return true;
      } catch (error) {
        await this.clearWxQuickLoginQuery();
        this.$message.error("用户暂未绑定微信账户，请扫码登录");
        return false;
      } finally {
        this.wxQuickLoginLoading = false;
      }
    },
    async clearWxQuickLoginQuery() {
      const query = Object.assign({}, this.$route.query);
      delete query.code;
      delete query.state;
      await this.$router.replace({ path: this.$route.path, query });
    },
    async getCheckActivityPopStatus(){
      const res = await getDicts('index_pop_pc')
        const data = res.data.find(item => item.remark == this.userInfo.unitId)
        if(data) {
					this.active_config = {
						pic: data.dictLabel,
						path: data.dictValue,
					}
					this.$refs.checkActivityDlgRef.publicOpen(this.active_config);
				}
    },
    openChat() {
      // globalVisitHandle.openInitiatedChat(!1)
      // _MICHAT.floatClick()
      window._MICHAT =
        window._MICHAT ||
        function () {
          (_MICHAT.a = _MICHAT.a || []).push(arguments);
        };
      _MICHAT("cptid", "67ba3eae18f2");
      _MICHAT("domain", "emdchk.xianshangkefu.net");
      (function (m, d, q, j, s) {
        (j = d.createElement(q)), (s = d.getElementsByTagName(q)[0]);
        j.async = true;
        j.charset = "UTF-8";
        j.src =
          ("https:" == document.location.protocol ? "https://" : "http://") +
          "emdchk.xianshangkefu.net/Web/JS/mivisit.js?_=t";
        s.parentNode.insertBefore(j, s);
      })(window, document, "script");
      // globalVisitHandle.openInitiatedChat('https://chat56.live800.com/live800/chatClient/chatbox1622974.jspc?companyID=1622974&configID=590199&jid=9350194081&s=1')
    },
    handleScroll() {
      //获取滚动时的高度
      // let scrollTop = document.documentElement.scrollTop
      // if (scrollTop < 60) {
      //   this.menuFontColor = '#000'
      //   this.menuBgcolor = '#fff'
      // }
      // if (scrollTop > 60) {
      //   this.menuFontColor = '#fff'
      //   this.menuBgcolor = 'rgba(0,0,0,0.2)'
      // }
    },
    toTop() {
      document.documentElement.scrollTop = 0;
    },
    releaseRequire() {
      this.$router.push({
        path: "/releaseRequire",
        query: { type: this.$route.query.type ? this.$route.query.type : 0 },
      });
    },
    materialTest() {
      this.$router.push({ path: "/materialTest", query: { type: 2 } });
    },
  },
};
</script>
<style scoped lang="scss">
.wx-quick-login-loading {
  position: fixed;
  z-index: 3000;
  inset: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  justify-content: center;
  color: #5CC300;
  background: rgba(255, 255, 255, 0.92);
  font-size: 14px;
}

.wx-quick-login-loading i {
  font-size: 30px;
}

.fix_right_handle {
  position: fixed;
  top: 43%;
  right: 50px;
  z-index: 2000;
}

.fix_main {
  display: flex;
  flex-flow: column;
  align-items: center;
}

.online_serve {
  cursor: pointer;
  color: #fff;
  width: 35px;
  height: 35px;
  padding: 20px;
  border-radius: 50%;
  font-size: 14px;
  background: #4f6efd;
  text-align: center;
  margin-bottom: 20px;
}

.fixed_other_handle {
  display: flex;
  flex-flow: column;
  align-items: center;
  width: 50px;
  height: 200px;
  background: #ffffff;
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.12);
  border-radius: 48px;
  padding: 20px 10px;
}

.other_handle_name {
  img {
    width: 50%;
    margin-bottom: 8px;
  }

  font-weight: 400;
  font-size: 12px;
  color: #afafaf;
  line-height: 14px;
  text-align: center;
  cursor: pointer;
}

.other_handle_name:hover {
  color: #4f6efd;
}

// 团购活动侧边logo
.actives-logo {
  margin-top: 20px;

  img {
    width: 60px;
    height: 84px;
  }
}

.actives-dialog {
  z-index: 999;
  position: fixed;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);

  @keyframes actives-logo {
    0% {
      width: 200px;
    }

    100% {
      width: 400px;
    }
  }

  img {
    animation: actives-logo linear 0.2s;
    width: 400px;
  }

  .el-icon-circle-close {
    margin-top: 50px;
    color: #fff;
    transform: scale(5);
  }
}

//广告dialog
</style>
<style>
.fix_right_handle .el-divider--horizontal {
  margin: 10px 0;
}

.chat_entry {
  position: fixed;
  top: -9999px;
  z-index: 99999;
}

#MICHAT-FLOAT-WRAP,
#MICHAT-MINI-BTN {
  position: fixed;
  top: -9999px;
  z-index: 99999;
}
</style>
